module.exports = __webpack_public_path__ + "media/images/pie/escu_centro-8bc7aa71e888cad8c191d32d1d886c32.png";